/*******************************************************************************
 * Copyright (c) 2025 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'psp-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {}
